import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { BaseModalComponent } from './base-modal/base-modal.component';
import { ProInfoComponent } from './components/pro-info/pro-info.component';
import { TooMuchLoadsComponent } from './components/too-much-loads/too-much-loads.component';
import { ProModalComponent } from './pro-modal/pro-modal.component';
import { PriceListInfoComponent } from './components/price-list-info/price-list-info.component';
import { MaxLoadsPopupComponent } from './components/maxLoadsPopup/max-loads-popup.component';
import { ErrorPopupComponent } from './components/error-popup/error-popup.component';
import { PalletOverflowRecommendationPopupComponent } from './components/pallet-overflow-recommendation-popup/pallet-overflow-recommendation-popup.component';
import {
  SubscriptionExpirePopupComponent
} from '../container/subscription-expire-popup/subscription-expire-popup.component';
import { PriceListUpdatePopupComponent } from '../container/price-list-update-popup/price-list-update-popup.component';

@NgModule({
    declarations: [BaseModalComponent, TooMuchLoadsComponent, ProModalComponent, ProInfoComponent, PriceListInfoComponent, MaxLoadsPopupComponent, ErrorPopupComponent, PalletOverflowRecommendationPopupComponent, SubscriptionExpirePopupComponent, PriceListUpdatePopupComponent],
    imports: [CommonModule, SharedModule],
    exports: [BaseModalComponent, TooMuchLoadsComponent, ProModalComponent, ProInfoComponent, MaxLoadsPopupComponent, ErrorPopupComponent, PalletOverflowRecommendationPopupComponent, SubscriptionExpirePopupComponent, PriceListUpdatePopupComponent]
})
export class ModalModule {}
